import { html } from '@shared/utils/rendering/html';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo } from 'preact/hooks';

import { CacheKeyNames } from '@core/constants/utility/cache-key-names';
import { useCache } from '@core/utils/context/cache-context';
import { usePost } from '@core/utils/hooks/use-post';

import Button from '@shared/components/buttons';
import NoTableResults from '@shared/components/tables/table-components/no-table-results';

export default function InitiateAssessment({ filters }) {
    const queryClient = useQueryClient();
    const getCache = useCache().getKey;

    const { post: createAssessment, isSubmitting, error } = usePost('/legal-entity-assessments');

    const onSuccessfulResponse = (queryClient, key, response) => {
        if (!key) return;

        queryClient.setQueryData(key, response);
    };

    const initiateMutation = useMutation({
        mutationFn: async (payload) => {
            const response = await createAssessment(payload);
            return response?.data ?? response;
        },
        onSuccess: (response) => {
            const key = getCache(CacheKeyNames.legalEntityAssessmentData)?.cacheKey;
            if (!key && !response) return;
            try {
                onSuccessfulResponse(queryClient, key, response);
            } catch (error) {
                console.error('Error updating cache:', error);
            }
        },
        onSettled: () => {
            const key = getCache(CacheKeyNames.legalEntityAssessmentData).cacheKey;
            queryClient.invalidateQueries({ queryKey: key });
        },
    });

    const onInitiateAssessment = useCallback(
        (data) => {
            if (isSubmitting) return;

            const payload = {
                ...filters,
            };
            initiateMutation.mutate(payload);
        },
        [initiateMutation, filters]
    );

    const initiateAttestationButton = useMemo(
        () =>
            html`<${Button}
                label=${{ text: 'Start new Assessment' }}
                onClick=${onInitiateAssessment}
            />`,
        [onInitiateAssessment]
    );
    return html` <${NoTableResults}
        message=${{
            text: 'No Assessment has been captured for this attestation period. Would you like to start one?',
        }}
        button=${initiateAttestationButton}
    />`;
}
